import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
    createStateSyncMiddleware,
    initMessageListener,
} from "../utils/custom-redux-state-sync";
import {thunk} from 'redux-thunk';

// import { createLogger } from "redux-logger";
import storage from "redux-persist/lib/storage";
import persistStore from "redux-persist/es/persistStore";
import persistReducer from 'redux-persist/es/persistReducer';
import taskDetailReducer from './reducers/taskDetail.reducer';
import userReducer from './reducers/user.reducer';
import snackbarReducer from './reducers/snackbar.reducer';
import errorReducer from './reducers/error.reducer';
import appSettingsReducer from './reducers/appSettings.reducer';
import envReducer from './reducers/env.reducer';
import clientDataReducer from './reducers/clientData.reducer';
import { SNACK_CLOSE, SNACK_OPEN } from './actions/actions.types';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['env', 'appSettings', 'user'],
};

const rootReducer = combineReducers({
    env: envReducer,
    user: userReducer,
    taskDetail: taskDetailReducer,
    snack: snackbarReducer,
    error: errorReducer,
    appSettings: appSettingsReducer,
    clientData: clientDataReducer
});

const middleware = [thunk];
// middleware.push(createLogger());
middleware.push(createStateSyncMiddleware({
    blacklist: ["persist/PERSIST", "persist/REHYDRATE",SNACK_OPEN, SNACK_CLOSE],
  }))
const enhancers = [...middleware];

export const store = configureStore(
    {
        reducer: persistReducer(persistConfig, rootReducer),
        middleware: (getDefaultMiddleware) => {
            getDefaultMiddleware({
                serializableCheck: false
            });
            
            return enhancers;
        },
    },
);

initMessageListener(store);

export const persistor = persistStore(store);